<div class="d-flex gx-2 mt-2">
    <div class="text-secondary preview-icon pe-1">
        <i class="fa-regular fa-clock"></i>
    </div>
    <div class="">
        <div class="px-3">
            {{ itemTypeText | translate}} {{'timeline-item-creation-dialog.publication-preview.now' | translate}}
        </div>
    </div>
</div>


